// click header close button start
  $(document).ready(function() {
    $('.custom-close').on('click', function() {
        $('.header__icon--menu.header__icon--summary').click();
    });
  });
// click header close button start

// featured collection slider starts here
    $('.collection.featured-collection .product-grid').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
          arrows: false
        }
      }
    ]
  });



// featured collection slider ends here

          

